module.exports = __webpack_public_path__ + "static/CannabisEssentials_Logo-f031c5e9d74fb30769ec816fd3cd4dd1.svg";